import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { EkycResultPage } from "@/features/ekyc/EkycResultPage";

const EkycResultSearchSchema = z.object({
  message: z.string(),
  isError: z.enum(["true", "false"]),
});

export const Route = createFileRoute("/ekyc/result")({
  validateSearch: EkycResultSearchSchema,
  component: EkycResultRouteComponent,
});

function EkycResultRouteComponent() {
  const { message, isError } = Route.useSearch();

  return (
    <EkycResultPage message={message} hasError={isError === "true"} />
  );
}
